import { render, staticRenderFns } from "./DeliveryProfit.vue?vue&type=template&id=62665e4c&lang=pug&"
import script from "./DeliveryProfit.vue?vue&type=script&lang=ts&"
export * from "./DeliveryProfit.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryProfit.vue?vue&type=style&index=0&id=62665e4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports